import React from 'react';
import Button from '@strava/ui/Button';

import I18n from 'utils/I18n';

import { clearCheckoutError } from '../../../state/Checkout.actions';
import { useCheckoutContext } from '../../../state/CheckoutContext';

import styles from './CheckoutError.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.form';

export const CheckoutError = () => {
  const { dispatch } = useCheckoutContext();
  return (
    <div className={styles.checkoutError}>
      <div className={styles.message}>
        <p className="text-center">
          {I18n.t(`${I18nPrefix}.payment_failure.we_are_sorry`)}
        </p>
        <p className="text-center">
          {I18n.t(`${I18nPrefix}.payment_failure.card_not_charged`)}
        </p>
      </div>
      <Button
        type="button"
        variant="primary"
        className={styles.cta}
        onClick={() => dispatch(clearCheckoutError())}
      >
        {I18n.t(`${I18nPrefix}.payment_failure.cta`)}
      </Button>
    </div>
  );
};

export default CheckoutError;
